import React from 'react';
import Select from '../Select/Select';

export const COLORS = [
  { value: '#FFFFFF', label: 'ÐÐµÐ»ÑÐ¹' },
  { value: '#000000', label: 'Ð§ÑÑÐ½ÑÐ¹' },
  { value: '#808080', label: 'Ð¡ÐµÑÑÐ¹' },
  { value: '#FF0000', label: 'ÐÑÐ°ÑÐ½ÑÐ¹' },
  { value: '#FFA500', label: 'ÐÑÐ°Ð½Ð¶ÐµÐ²ÑÐ¹' },
  { value: '#FFFF00', label: 'ÐÑÐ»ÑÑÐ¹' },
  { value: '#00FF00', label: 'ÐÐµÐ»ÑÐ½ÑÐ¹' },
  { value: '#00bfff', label: 'ÐÐ¾Ð»ÑÐ±Ð¾Ð¹' },
  { value: '#0000ff', label: 'Ð¡Ð¸Ð½Ð¸Ð¹' },
  { value: '#800080', label: 'Ð¤Ð¸Ð¾Ð»ÐµÑÐ¾Ð²ÑÐ¹' },
  { value: '#964b00', label: 'ÐÐ¾ÑÐ¸ÑÐ½ÐµÐ²ÑÐ¹' },
  { value: '#FFEFDF', label: 'ÐÐµÐ¶ÐµÐ²ÑÐ¹' },
  // ÐÑÑÐµÐ½ÐºÐ¸ Ð¸Ð· Ð¿ÑÐ°Ð¹ÑÐ¾Ð² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÐµÐ¹ â Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÑÐ¾ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐµ ÑÐ²ÐµÑÐ°
  { value: '#0B1F3A', label: 'Ð¢ÑÐ¼Ð½Ð¾-ÑÐ¸Ð½Ð¸Ð¹' },
  { value: '#4A90D9', label: 'ÐÐµÐ±ÐµÑÐ½Ð¾-ÑÐ¸Ð½Ð¸Ð¹' },
  { value: '#A7D3F0', label: 'Ð¡Ð²ÐµÑÐ»Ð¾-Ð³Ð¾Ð»ÑÐ±Ð¾Ð¹' },
  { value: '#C0C0C0', label: 'Ð¡Ð²ÐµÑÐ»Ð¾-ÑÐµÑÑÐ¹' },
  { value: '#4F4F4F', label: 'Ð¢ÑÐ¼Ð½Ð¾-ÑÐµÑÑÐ¹' },
  { value: '#F7F9FA', label: 'Ð¡Ð½ÐµÐ¶Ð½Ð¾-Ð±ÐµÐ»ÑÐ¹' },
  { value: '#F2EFE6', label: 'ÐÐµÐ»ÑÐ¹ Ð¶ÐµÐ¼ÑÑÐ¶Ð½ÑÐ¹' },
  { value: '#D6D6D6', label: 'Ð¡ÐµÑÐµÐ±ÑÐ¸ÑÑÑÐ¹' },
  { value: '#D4AF37', label: 'ÐÐ¾Ð»Ð¾ÑÐ¸ÑÑÑÐ¹' },
  { value: '#C2B280', label: 'ÐÐµÑÐ¾ÑÐ½ÑÐ¹' },
];

const SelectColor = ({ label, ...props }) => {
  return <Select options={COLORS} label={label || 'Ð¦Ð²ÐµÑ'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectColor;
